var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters, Utils } from '@pacem/pacem-core';
import { TAG_MIDDLE_NAME } from '../constants';
import { KnownShader, MaterialElement } from './material';
//namespace Pacem.Components.Drawing3D {
let StandardMaterialElement = class StandardMaterialElement extends MaterialElement {
    constructor() {
        super(KnownShader.Standard);
    }
    async createMaterial() {
        return Utils.extend({
            emissiveColor: this.emissiveColor || '#000',
            refractionRatio: this.refractionRatio ?? 0,
            metalness: this.metalness ?? 0,
            roughness: this.roughness ?? 0,
            flatShading: this.flatShading ?? false
        }, await super.createMaterial());
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'emissiveColor':
                case 'roughness':
                case 'metalness':
                case 'refractionRatio':
                case 'flatShading':
                    this.updateMaterial();
                    break;
            }
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], StandardMaterialElement.prototype, "emissiveColor", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], StandardMaterialElement.prototype, "refractionRatio", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], StandardMaterialElement.prototype, "roughness", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], StandardMaterialElement.prototype, "metalness", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], StandardMaterialElement.prototype, "flatShading", void 0);
StandardMaterialElement = __decorate([
    CustomElement({ tagName: `${P}-${TAG_MIDDLE_NAME}-material-standard` })
], StandardMaterialElement);
export { StandardMaterialElement };
